/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-undef */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from "react";
import PostAddIcon from "@mui/icons-material/PostAdd";
import AddIcon from "@mui/icons-material/Add";
import {
  Assignment as AssignmentIcon,
  Close as CloseIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import SettingsIcon from "@mui/icons-material/Settings";
import useAxiosPrivate from "contexts/interceptors/axios";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useStateContext } from "../../../../../contexts/ContextProvider";
import AddPostModal from "../../../../../modals/i-abide/CreatePost";
import ViewPostModal from "../../../../../modals/i-abide/ViewPostModal";
import SubmitModal from "../../../../../modals/i-abide/SubmitFormModal";

export default function IABIDESchoolDashboard() {
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [viewRemarkDialogOpen, setViewRemarkDialogOpen] = useState(false);

  const [openSubmitModal, setOpenSubmitModal] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState();
  const [viewPostId, setViewPostId] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // const [submittedPosts, setSubmittedPosts] = useState([]);
  const [submissionStatus, setSubmissionStatus] = useState({});
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useStateContext();

  const handleGetAll = () => {
    // setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-Abide/getAllPosts`)
      .then((res) => {
        console.log(res);

        const sortedPosts = res.data.data.sort(
          (a, b) => new Date(b.posting_date) - new Date(a.posting_date)
        );
        setData(sortedPosts);
      })
      .catch((error) => {
        setError(error?.message || "an error occured");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function getPreviewUrl(FileId) {
    return `https://drive.google.com/file/d/${FileId}/preview`;
  }

  const handlePreview = (fileId, title) => {
    if (!fileId) {
      console.error("No file ID provided for preview.");
      return;
    }

    const previewUrl = getPreviewUrl(fileId);
    setPreviewUrl(previewUrl); // Set the preview URL to state
    setPreviewTitle(title); // Set the material title to state
    setPreviewModalOpen(true); // Open the preview modal
  };

  const handleClosePreviewModal = () => {
    setPreviewModalOpen(false); // Close the preview modal
    setPreviewUrl(""); // Clear the preview URL
    setPreviewTitle(""); // Clear material title
  };

  useEffect(() => {
    if (auth?.role === "admin" && !auth?.recipient_typeId) {
      handleGetAll();
    } else if (
      (auth?.role === "teacher" ||
        auth?.role === "school head" ||
        auth?.role === "school non-teaching personnel") &&
      auth?.recipient_typeId
    ) {
      axiosPrivate
        .get(`/I-Abide/getPostByRecipient`, {
          params: {
            officeId: auth?.officeId,
            recipient_typeId: auth?.recipient_typeId,
          },
        })
        .then((res) => {
          setData(res?.data);
        })
        .catch((error) => {
          console.error("Error fetching posts:", error.message);
          setError(error.message);
        })
        .finally(() => setLoading(false));
    }
  }, [auth]);

  const handleView = (postId) => {
    setViewPostId(postId);
    setOpenViewModal(true);
  };

  const handleOpenSubmit = (postId) => {
    // const isResubmission = submissionStatus[postId] === "Rejected";
    setSelectedPostId(postId);
    setOpenSubmitModal(true);
  };

  const handlePreviewByPost = (username, postId) => {
    axiosPrivate
      .get(`/I-Abide/getSubmissionByPostandUser`, {
        params: { username, id: postId },
      })
      .then((res) => {
        if (res?.data?.FileId) {
          handlePreview(res?.data?.FileId, res?.data?.postTitle);
          setRemarks(res?.data?.remarks);
        } else {
          console.error("No file ID found for preview.");
        }
      })
      .catch((error) => {
        console.error("Error fetching preview:", error.message);
      });
  };

  const handleSubmissionSuccess = () => {
    // setSubmittedPosts((prev) => [...prev, postId]);
    setOpenSubmitModal(false);
  };

  const handleViewRemark = () => {
    setViewRemarkDialogOpen(true);
  };

  const handleCloseViewRemarkDialog = () => {
    setViewRemarkDialogOpen(false);
  };

  const fetchSubmissionStatuses = () => {
    if (auth?.role !== "admin" && data.length > 0) {
      const fetchStatuses = async () => {
        const statuses = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const post of data) {
          axiosPrivate
            .get(`/I-Abide/getSubmissionByPostandUser`, {
              params: { username: auth?.username, id: post.id },
            })
            .then((res) => {
              if (res?.data) {
                statuses[post.id] = res?.data?.status; // Assuming "status" is the field you want
              }
            })
            .catch((error) => {
              console.error(
                `Error fetching status for post ${post.id}:`,
                error
              );
            });
        }
        setSubmissionStatus(statuses);
      };

      fetchStatuses();
    }
  };

  useEffect(() => {
    fetchSubmissionStatuses();
  }, [data, auth]);

  return (
    <Box p={1}>
      <Box sx={{ p: 2, background: "black" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            gap: 2,
          }}
        >
          <PostAddIcon style={{ fontSize: 50, color: "#ecfc08" }} />
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontWeight: "bold",
              color: "white",
            }}
          >
            {auth?.role === "admin" ? "POSTS" : "SUBMISSIONS"}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", p: 1 }}>
        {auth?.role === "admin" && (
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="outlined"
              color="primary"
              endIcon={<AddIcon />}
              sx={{
                fontSize: "1.2rem",
                padding: "12px 24px",
                minWidth: "180px",
                "&:hover": {
                  backgroundColor: "#007BFF",
                  borderColor: "#0056b3",
                  color: "#fff",
                },
              }}
              onClick={() => setOpenModal(true)}
            >
              CREATE POST
            </Button>
          </Box>
        )}
      </Box>

      {loading && <CircularProgress />}
      {error && <Typography color="error">{error}</Typography>}

      <Box>
        {data.length > 0 ? (
          <List>
            {data
              .filter((post) => submissionStatus[post.id] !== "Accepted") // Filter out "Accepted" posts
              .map((post) => (
                <ListItem key={post.id}>
                  <Paper elevation={3} sx={{ p: 2, width: "100%" }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography variant="h6">
                          {post.post_title}
                          {post.submitters &&
                            post?.submitters
                              .map((submitter) => submitter?.id)
                              .includes(auth?.uid) && (
                              <Typography
                                component="span"
                                sx={{
                                  marginLeft: 2,
                                  color: "green",
                                  fontWeight: "bold",
                                }}
                              >
                                submitted
                                {submissionStatus[post.id] && (
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color:
                                        submissionStatus[post.id] === "Accepted"
                                          ? "green"
                                          : submissionStatus[post.id] ===
                                            "Pending Acceptance"
                                          ? "orange"
                                          : submissionStatus[post.id] ===
                                            "Rejected"
                                          ? "red"
                                          : "inherit", // Default color if no match
                                    }}
                                  >
                                    {submissionStatus[post.id]}
                                  </Typography>
                                )}
                              </Typography>
                            )}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <Typography>DUE: </Typography>
                          <Typography>
                            {dayjs(post.deadline).format("MMMM D, YYYY h:mm A")}
                          </Typography>
                          {auth?.role !== "admin" ? (
                            <Typography
                              sx={{ fontFamily: "Poppins", fontWeight: "bold" }}
                            >
                              {post.status}
                            </Typography>
                          ) : null}
                        </Box>
                      </Box>

                      {/* Icons on the Right */}
                      <Box display="flex" gap={1}>
                        {/* View Tooltip */}
                        <Tooltip title="View" arrow>
                          <IconButton
                            onClick={() => handleView(post.id)}
                            sx={{ color: "#2e3887" }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>

                        {/* Submissions Tooltip */}
                        {auth?.role === "admin" && (
                          <Tooltip title="Submissions" arrow>
                            <IconButton
                              onClick={() => handleSubmissions(post.id)}
                              sx={{ color: "red" }}
                            >
                              <LeaderboardIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        {/* Submissions Tooltip for viewing preview */}
                        {auth?.role !== "admin" && (
                          <Tooltip title="Preview Submission" arrow>
                            <IconButton
                              onClick={() =>
                                handlePreviewByPost(auth?.username, post.id)
                              }
                              sx={{ color: "#2e3887" }}
                            >
                              <AssignmentIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        {auth?.role !== "admin" && (
                          <Tooltip
                            title={
                              post.submitters
                                ?.map((submitter) => submitter?.id)
                                .includes(auth?.uid) &&
                              submissionStatus[post.id] !== "Rejected"
                                ? "Already Submitted"
                                : "Submit Document"
                            }
                            disableHoverListener={
                              post.submitters
                                ?.map((submitter) => submitter?.id)
                                .includes(auth?.uid) &&
                              submissionStatus[post.id] !== "Rejected"
                            }
                          >
                            <span>
                              <Button
                                variant="contained"
                                onClick={() => handleOpenSubmit(post.id)}
                                disabled={
                                  post.submitters
                                    ?.map((submitter) => submitter?.id)
                                    .includes(auth?.uid) &&
                                  submissionStatus[post.id] !== "Rejected"
                                }
                              >
                                Submit
                              </Button>
                            </span>
                          </Tooltip>
                        )}

                        {/* Options Tooltip */}
                        {auth?.role === "admin" && (
                          <Tooltip title="Options" arrow>
                            <IconButton sx={{ color: "black" }}>
                              <SettingsIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                  </Paper>
                </ListItem>
              ))}
          </List>
        ) : (
          !loading && <Typography>No posts available.</Typography>
        )}
      </Box>

      <Modal
        open={previewModalOpen}
        onClose={handleClosePreviewModal}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "70%",
            maxHeight: "90%",
            overflow: "auto",
            backgroundColor: "#ccfcff",
            boxShadow: 24,
            borderRadius: 4,
            padding: 2,
            position: "relative",
          }}
        >
          <IconButton
            onClick={handleClosePreviewModal}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "grey",
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ py: 3 }}>
            <Typography variant="h6" sx={{ color: "black" }}>
              {previewTitle}
            </Typography>
          </Box>

          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%", // Aspect ratio of 16:9
            }}
          >
            <iframe
              src={previewUrl}
              title="PDF Preview"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
                overflow: "auto",
              }}
            />
          </Box>

          {/* View Remarks Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              textAlign: "center",
              marginTop: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleViewRemark} // Create this handler function
            >
              View Remarks
            </Button>
          </Box>
        </Box>
      </Modal>

      <Dialog
        open={viewRemarkDialogOpen}
        onClose={handleCloseViewRemarkDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Remark</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {remarks || "No remarks available."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewRemarkDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <AddPostModal open={openModal} handleClose={() => setOpenModal(false)} />
      <ViewPostModal
        open={openViewModal}
        handleClose={() => setOpenViewModal(false)}
        postId={viewPostId}
      />
      <SubmitModal
        open={openSubmitModal}
        handleClose={() => setOpenSubmitModal(false)}
        data={selectedPostId}
        onSubmitSuccess={handleSubmissionSuccess}
        submissionStatus={submissionStatus}
      />
    </Box>
  );
}
